




















































































import Vue from 'vue';
import Button, {ButtonTypes} from '@common/button/button.vue';
import SkeletonWrapper from '@common/skeleton-wrapper.vue';
// import {ToggleComponent} from '@mobi-components/toggle';
import BaseCard from './base-card.vue';

export default Vue.extend({
  components: {
    Button,
    SkeletonWrapper,
    // ToggleComponent,
    BaseCard,
  },
  name: 'TripSummaryCard',
  props: {
    category: String,
    title: String,
    subTitle: {
      type: String,
      default: null,
    },
    images: Array,
    priceLabel: String,
    price: String,
    matchedTags: Array,
    showTags: Boolean,
    showMatchAndPrice: {type: Boolean, default: () => true},
    firstButtonLabel: {type: String, default: 'More Options'},
    secondButtonLabel: {type: String, default: 'Book'},
    showToggle: {type: Boolean, default: () => false},
    showPicks: {type: Boolean, default: () => false},
    preferenceSelected: Boolean,
    isOn: {type: Boolean, default: () => true},
    isLoading: Boolean,
    picks: String,
    detailsRoute: String,
    selectRoute: String,
  },
  data() {
    return {
      ButtonTypes,
    };
  },
  computed: {
    categoryClassName(): string {
      return `trip-summary-card category-${this.category?.toLowerCase() || 'none'}`;
    },
    imagesList(): string[] {
      return (this.images as string[]) || [''];
    },
    isPreferenceSelected(): boolean {
      return !!this.picks;
    },
  },
  methods: {
    onDetailsClick() {
      this.$emit('details-click');
    },
    onItinerary() {
      this.$emit('itinerary-click');
    },
    onToggle() {
      this.$emit('toggle-exp');
    },
    onPreferencesClick() {
      this.$emit('preferences-click');
    },
  },
});
